'use strict';

export const serializableMappingCache = {
  set(_serializable, _serializableRef) {
    // NOOP
  },
  get(_key) {
    return null;
  }
};
//# sourceMappingURL=serializableMappingCache.js.map